function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M120.4 201.1l-46.7-46.6-20.1 20 66.8 66.7 116.1-116.3-20.1-20-96 96.2zm106.3-194V0h-28.4v7.1H92.2V0H63.8v7.1H0v276.4h283.5V7.1h-56.8zM28.3 35.4h35.5v7.1h28.4v-7.1h106.1v7.1h28.4v-7.1h28.4v28.3H28.3V35.4zm0 219.7V91.8h226.8v163.3H28.3z"
})));